module.exports = __webpack_public_path__ + "static/media/red_nebula_FT.de4856d4.png";